import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
/**
 * Scale an image from a file input to specified dimensions
 *
 * If the specified dimensions are not proportional to the image dimensions
 * the output image will be cropped at center
 *
 * Based on https://stackoverflow.com/a/72728396
 */

export function scaleImage(_x, _x2) {
  return _scaleImage.apply(this, arguments);
}
function _scaleImage() {
  _scaleImage = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(file, dimensions) {
    var image, canvas, context, scaleProportions, scaledWidth, _scaleProportions, scaledHeight, blob;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (file.type.match(/image.*/)) {
            _context.next = 1;
            break;
          }
          return _context.abrupt("return", null);
        case 1:
          image = new Image();
          image.src = URL.createObjectURL(file);
          _context.next = 2;
          return new Promise(function (res) {
            return image.onload = res;
          });
        case 2:
          canvas = document.createElement('canvas');
          context = canvas.getContext('2d', {
            alpha: true
          });
          if (context) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", null);
        case 3:
          canvas.width = dimensions.width;
          canvas.height = dimensions.height;
          if (image.height <= image.width) {
            scaleProportions = canvas.height / image.height;
            scaledWidth = scaleProportions * image.width;
            context.drawImage(image, (canvas.width - scaledWidth) / 2, 0, scaledWidth, canvas.height);
          } else {
            _scaleProportions = canvas.width / image.width;
            scaledHeight = _scaleProportions * image.height;
            context.drawImage(image, 0, (canvas.height - scaledHeight) / 2, canvas.width, scaledHeight);
          }
          _context.next = 4;
          return new Promise(function (resolve) {
            return canvas.toBlob(resolve, file.type || 'image/jpeg', 0.95);
          });
        case 4:
          blob = _context.sent;
          return _context.abrupt("return", blob ? new File([blob], file.name, {
            type: file.type
          }) : null);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _scaleImage.apply(this, arguments);
}